import styled, { css, keyframes } from 'styled-components'

export const HeaderWrapper = styled.div<{ $hideOnDesktop?: boolean }>`
  width: 100%;
  ${({ $hideOnDesktop }) =>
    $hideOnDesktop &&
    css`
      @media (min-width: 1201px) {
        display: none !important;
      }
    `}
`

export const MainTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const MobileMenuContainer = styled.div<{ $isOpen: boolean }>`
  display: none;

  @media (max-width: 1200px) {
    position: fixed;
    bottom: ${({ $isOpen }) => ($isOpen ? '0' : '20px')};
    right: ${({ $isOpen }) => ($isOpen ? '0' : '30px')};
    width: 100%;
    pointer-events: none;
    display: flex;
    justify-content: end;
    align-items: flex-end;
    z-index: 999999999999;

    .mobile-bar {
      position: absolute;
      bottom: ${({ $isOpen }) => ($isOpen ? '0' : '20px')};
      width: ${({ $isOpen }) => ($isOpen ? '100%' : '60px')};
      height: ${({ $isOpen }) => ($isOpen ? '90px' : '60px')};
      border-radius: ${({ $isOpen }) => ($isOpen ? '0' : '50%')};

      background-color: #002b80;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      pointer-events: auto;
      z-index: 2;

      box-shadow: ${({ $isOpen }) => ($isOpen ? 'none' : '0 4px 15px rgba(0, 0, 0, 0.4)')};

      .hamburger-btn {
        background: transparent;
        border: none;
        color: #ffffff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        transition: all 0.3s;

        &:active {
          transform: scale(0.85);
        }
      }
    }
  }
`

export const ExpandedMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  bottom: 90px;
  left: 0;
  width: 100%;
  max-height: 75vh;
  overflow-y: auto;
  background-color: #002b80;
  border-radius: 20px 20px 0 0;
  padding: 30px 20px 10px 20px;
  pointer-events: auto;

  transform: translateY(${({ $isOpen }) => ($isOpen ? '0' : '5%')});
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 1;

  .menu-items {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`

export const NavButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  border: none;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  gap: 20px;
  cursor: pointer;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    font-size: 24px;
    transition: all 0.3s ease;
    margin: 0;
  }

  span {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
    transition: all 0.3s ease;
  }

  ${({ $active }) =>
    $active &&
    css`
      p {
        background-color: #ffffff;
        color: #002b80;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
      }
      span {
        font-weight: 700;
        color: #a6c10b;
      }
    `}
`

export const WebMenuContainer = styled.div`
  @media (max-width: 1200px) {
    display: none;
  }

  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  .mobile-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    border-radius: 50px;
    width: auto;
    height: auto;
    max-width: 1200px;
    position: relative;
    background: ${(props) => props.theme.navBackground};
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(12px);
    transition: all 0.3s ease;
    a {
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
`

export const WebNavButton = styled.button<{ $active: boolean; $highlightColor?: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  color: rgb(187, 187, 187);
  font-size: 24px;
  height: 48px;
  width: 48px;
  min-width: 48px;
  cursor: pointer;
  padding: 0;
  border-radius: 12px;
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    border-radius: 12px;
    background-color: transparent;
    color: rgb(187, 187, 187);
    transition: all 0.25s ease;
    margin: 0;
  }

  span {
    position: absolute;
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%) translateY(6px);
    background: rgba(0, 20, 60, 0.96);
    color: #ffffff;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 11px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.45);
    border: 1px solid rgba(166, 193, 11, 0.35);
    backdrop-filter: blur(8px);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
    z-index: 999999;

    &::before {
      content: '';
      position: absolute;
      top: -5px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 0 5px 5px 5px;
      border-style: solid;
      border-color: transparent transparent rgba(0, 20, 60, 0.96) transparent;
    }
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);

    p {
      color: #ffffff;
      transform: scale(1.08);
    }

    span {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(0);
    }
  }

  ${({ $active, $highlightColor }) => {
    const color = $highlightColor || '#a6c10b'
    return (
      $active &&
      css`
        background: ${color}26;
        border: 1px solid ${color}80;
        box-shadow: 0 0 12px ${color}33;

        p {
          color: ${color};
        }

        &:hover {
          background: ${color}40;
          p {
            color: ${color};
          }
        }
      `
    )
  }}
`

export const AppMainLayout = styled.div<{ $isVertical: boolean }>`
  display: flex;
  width: 100%;
  min-height: 100vh;
  position: relative;
`

export const VerticalSidebar = styled.aside<{ $collapsed?: boolean }>`
  @media (max-width: 1200px) {
    display: none;
  }
  width: ${({ $collapsed }) => ($collapsed ? '78px' : '240px')};
  height: 100vh;
  max-height: 100vh;
  background: #001f5c;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  flex-direction: column;
  padding: 14px 10px;
  gap: 6px;
  transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);
  position: sticky;
  top: 0;
  align-self: flex-start;
  z-index: 99999;
  box-sizing: border-box;

  .sidebar-header-toggle {
    display: flex;
    align-items: center;
    justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'flex-end')};
    padding: 2px 4px 8px 4px;
    flex-shrink: 0;

    .collapse-btn {
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 8px;
      color: #94a3b8;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #a6c10b;
        color: #001842;
      }
    }
  }

  .sidebar-nav-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 2px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(166, 193, 11, 0.3);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #a6c10b;
    }
  }
`

export const SidebarUserSection = styled.div<{ $collapsed?: boolean }>`
  position: relative;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;

  .user-card-clickable {
    display: flex;
    align-items: center;
    justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'flex-start')};
    gap: 10px;
    padding: ${({ $collapsed }) => ($collapsed ? '8px 4px' : '10px 12px')};
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.1);
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(166, 193, 11, 0.4);
    }

    .avatar {
      width: 38px;
      height: 38px;
      min-width: 38px;
      border-radius: 50%;
      background: #002b80;
      border: 2px solid #a6c10b;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 13px;
      font-weight: 700;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    }

    .user-info {
      display: ${({ $collapsed }) => ($collapsed ? 'none' : 'flex')};
      flex-direction: column;
      overflow: hidden;
      flex: 1;

      .nickname {
        font-size: 13px;
        font-weight: 700;
        color: #ffffff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .role {
        font-size: 10px;
        color: #a6c10b;
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    .chevron-indicator {
      display: ${({ $collapsed }) => ($collapsed ? 'none' : 'flex')};
      align-items: center;
      justify-content: center;
      color: #94a3b8;
      transition: transform 0.2s ease;
    }
  }
`

export const SidebarUserDropdown = styled.div<{ $collapsed?: boolean }>`
  position: absolute;
  ${({ $collapsed }) =>
    $collapsed
      ? css`
          bottom: 0;
          left: calc(100% + 12px);
          width: 200px;
        `
      : css`
          bottom: calc(100% + 8px);
          left: 0;
          right: 0;
          width: 100%;
        `}
  background: #001842;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  z-index: 100000;
  backdrop-filter: blur(14px);
  animation: userDropdownAnim 0.2s ease-out;

  @keyframes userDropdownAnim {
    from {
      opacity: 0;
      transform: translateY(6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 12px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #f8fafc;
    text-decoration: none;
    transition: all 0.2s ease;
    text-align: left;
    box-sizing: border-box;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }

    &.logout,
    &.logout-action {
      width: 100% !important;
      height: auto !important;
      min-height: 40px !important;
      border-radius: 8px !important;
      border: none !important;
      background: transparent !important;
      color: #f87171 !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      text-transform: none !important;
      box-shadow: none !important;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 10px !important;
      padding: 10px 12px !important;

      &:hover {
        background: rgba(239, 68, 68, 0.15) !important;
        color: #ef4444 !important;
        transform: none !important;
        border-color: transparent !important;
      }

      svg {
        color: #ef4444 !important;
        font-size: 18px !important;
        min-width: 18px !important;
      }

      span {
        font-size: 13px !important;
        font-weight: 600 !important;
        color: inherit !important;
        text-transform: none !important;
      }
    }
  }

  .dropdown-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    margin: 3px 0;
  }
`

export const HorizontalUserSection = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .user-card-clickable {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px;
    border-radius: 14px;
    background: ${(props) => (props.theme.name === 'light' ? props.theme.navBackground : 'rgba(0, 0, 0, 0.25)')};
    border: 1px solid ${(props) => (props.theme.name === 'light' ? 'rgba(255, 255, 255, 0.18)' : 'rgba(255, 255, 255, 0.1)')};
    box-shadow: ${(props) => (props.theme.name === 'light' ? '0 6px 20px rgba(0, 0, 0, 0.18)' : 'none')};
    backdrop-filter: blur(12px);
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;

    &:hover {
      background: ${(props) => (props.theme.name === 'light' ? '#00297a' : 'rgba(255, 255, 255, 0.1)')};
      border-color: rgba(166, 193, 11, 0.5);
    }

    .avatar {
      width: 38px;
      height: 38px;
      min-width: 38px;
      border-radius: 50%;
      background: #002b80;
      border: 2px solid #a6c10b;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 13px;
      font-weight: 700;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    }

    .user-info {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      max-width: 140px;

      .nickname {
        font-size: 13px;
        font-weight: 700;
        color: #ffffff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .role {
        font-size: 10px;
        color: #a6c10b;
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    .chevron-indicator {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${(props) => (props.theme.name === 'light' ? 'rgba(255, 255, 255, 0.85)' : '#94a3b8')};
      transition: transform 0.2s ease;
    }

    @media (max-width: 768px) {
      padding: 4px;
      .user-info,
      .chevron-indicator {
        display: none;
      }
    }
  }
`

export const HorizontalUserDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 220px;
  background: ${(props) => (props.theme.name === 'light' ? props.theme.navBackground : '#001842')};
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  z-index: 100000;
  backdrop-filter: blur(14px);
  animation: userDropdownAnim 0.2s ease-out;

  @keyframes userDropdownAnim {
    from {
      opacity: 0;
      transform: translateY(6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 12px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #f8fafc;
    text-decoration: none;
    transition: all 0.2s ease;
    text-align: left;
    box-sizing: border-box;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }

    &.logout,
    &.logout-action {
      width: 100% !important;
      height: auto !important;
      min-height: 40px !important;
      border-radius: 8px !important;
      border: none !important;
      background: transparent !important;
      color: #f87171 !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      text-transform: none !important;
      box-shadow: none !important;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 10px !important;
      padding: 10px 12px !important;

      &:hover {
        background: rgba(239, 68, 68, 0.15) !important;
        color: #ef4444 !important;
        transform: none !important;
        border-color: transparent !important;
      }

      svg {
        color: #ef4444 !important;
        font-size: 18px !important;
        min-width: 18px !important;
      }

      span {
        font-size: 13px !important;
        font-weight: 600 !important;
        color: inherit !important;
        text-transform: none !important;
      }
    }
  }

  .dropdown-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    margin: 3px 0;
  }
`

export const SidebarFilterSection = styled.div<{ $collapsed?: boolean }>`
  margin-bottom: 8px;

  .sidebar-filter-btn {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'flex-start')};
    gap: 12px;
    padding: 0 12px;
    border-radius: 10px;
    border: 1px solid rgba(166, 193, 11, 0.4);
    background: rgba(166, 193, 11, 0.12);
    color: #a6c10b;
    font-weight: 700;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;

    span {
      display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
      white-space: nowrap;
    }

    &:hover {
      background: #a6c10b;
      color: #001842;
      box-shadow: 0 4px 12px rgba(166, 193, 11, 0.3);
    }
  }
`

export const VerticalNavButton = styled.button<{
  $active: boolean
  $highlightColor?: string
  $collapsed?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.2s ease;
  position: relative;
  text-align: left;

  .icon-wrap {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.05);
    color: rgb(187, 187, 187);
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  span {
    font-size: 12px;
    font-weight: 500;
    color: rgb(220, 220, 220);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.2s ease;
    display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);

    .icon-wrap {
      color: #ffffff;
      transform: scale(1.08);
    }
    span {
      color: #ffffff;
    }
  }

  ${({ $active, $highlightColor }) => {
    const color = $highlightColor || '#a6c10b'
    return (
      $active &&
      css`
        background: ${color}20;
        border-color: ${color}66;

        .icon-wrap {
          background: ${color}33;
          color: ${color};
        }
        span {
          font-weight: 700;
          color: ${color};
        }
      `
    )
  }}
`

export const ContentArea = styled.main<{ $isVertical: boolean }>`
  flex: 1;
  min-width: 0;
  width: 100%;
  padding-top: ${({ $isVertical }) => ($isVertical ? '20px' : '0')};
`

export const filterDrawerSlideIn = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`

export const filterBackdropFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const FilterBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  z-index: 9999999998;
  animation: ${filterBackdropFadeIn} 300ms ease;
`

export const FilterModal = styled.div`
  display: flex;
  position: fixed;
  flex-direction: column;
  z-index: 9999999999;
  align-items: stretch;
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  width: 520px;
  max-width: 100vw;
  top: 0;
  left: 0;
  border-radius: 0 14px 14px 0;
  box-shadow: 8px 0 30px rgba(0, 0, 0, 0.5);
  background-color: #001842;
  overflow: hidden;
  will-change: transform;
  animation: ${filterDrawerSlideIn} 350ms cubic-bezier(0.16, 1, 0.3, 1) forwards;

  @media (max-width: 600px) {
    width: 100%;
    max-width: 100vw;
    height: 100%;
    height: 100dvh;
    border-radius: 0;
  }

  .header {
    height: 50px;
    min-height: 50px;
    flex-shrink: 0;
    width: 100%;
    color: #ffffff;
    background-color: #002b80;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    font-size: 12px;
    position: relative;
  }
  .body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: #001842;
    color: #ffffff;
    padding: 20px;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.3);

    /* Modern Custom Scrollbar */
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.2);
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(166, 193, 11, 0.4);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #a6c10b;
    }

    select {
      height: 40px;
      border: none;
      border-radius: 27px;
      width: 100%;
      padding: 0 10px;
      box-shadow: 0px 2px 20px 1px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      padding: 0 20px;

      &:focus {
        outline: none;
      }
    }

    .button {
      display: flex;
      width: 100%;
      justify-content: end;
      gap: 10px;
    }

    .cancel {
      background-color: #990000;
    }

    .ok {
      transition: all ease-in-out 400ms;

      background-color: #274e13;
      &:disabled {
        background-color: #7e7e7e93;
        transition: all ease-in-out 1s;
      }
    }

    .buttons {
      background-color: #00205b;
    }

    .react-calendar {
      width: 350px;
      position: absolute;
      right: 0;
      top: 100px;
      padding: 10px 20px;
      max-width: 100%;
      background: white;
      z-index: 200000000000000000;
      border: none;
      border-radius: 10px;
      font-family: 'Montserrat', Arial, Helvetica, sans-serif;
      line-height: 1.125em;
    }
    .react-calendar--doubleView {
      width: 700px;
    }
    .react-calendar--doubleView .react-calendar__viewContainer {
      display: flex;
      margin: -0.5em;
    }
    .react-calendar--doubleView .react-calendar__viewContainer > * {
      width: 50%;
      margin: 0.5em;
    }
    .react-calendar,
    .react-calendar *,
    .react-calendar *:before,
    .react-calendar *:after {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .react-calendar button {
      margin: 0;
      border: 0;
      outline: none;
    }
    .react-calendar button:enabled:hover {
      cursor: pointer;
    }
    .react-calendar__navigation {
      height: 44px;
      margin-bottom: 1em;
    }
    .react-calendar__navigation button {
      min-width: 44px;
      background: none;
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
      background-color: #e6e6e6;
    }
    .react-calendar__navigation button[disabled] {
      background-color: #f0f0f0;
    }
    .react-calendar__month-view__weekdays {
      text-align: center;
      text-transform: capitalize;
      font-weight: bold;
      font-size: 0.75em;
    }

    .react-calendar__month-view__weekdays__weekday {
      padding: 0.2em;
    }
    .react-calendar__month-view__weekNumbers {
      font-weight: bold;
    }
    .react-calendar__month-view__weekNumbers .react-calendar__tile {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75em;
      padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
    }
    .react-calendar__month-view__days__day--weekend {
      color: #d10000;
    }
    .react-calendar__month-view__days__day--neighboringMonth {
      color: #757575;
    }
    .react-calendar__year-view .react-calendar__tile,
    .react-calendar__decade-view .react-calendar__tile,
    .react-calendar__century-view .react-calendar__tile {
      padding: 2em 0.5em;
    }
    .react-calendar__tile {
      max-width: 100%;
      text-align: center;
      padding: 0;
      background: none;
      width: 10px;
      height: 50px;
    }
    .react-calendar__tile:disabled {
      background-color: #f0f0f0;
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
      background-color: #002b80;
      color: #ffffff;
      border-radius: 500px;
    }
    .react-calendar__tile--now {
      background: #100797ff;
      color: #ffffff;
      border-radius: 500px;
    }
    .react-calendar__tile--now:enabled:hover,
    .react-calendar__tile--now:enabled:focus {
      background: #1509b8ff;
      border-radius: 500px;
    }
    .react-calendar__tile--hasActive {
      background: #76baff;
      border-radius: 500px;
    }
    .react-calendar__tile--hasActive:enabled:hover,
    .react-calendar__tile--hasActive:enabled:focus {
      background: #a9d4ff;
      border-radius: 500px;
    }
    .react-calendar__tile--active {
      background: #006edc;
      color: white;
      border-radius: 500px;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
      background: #1087ff;
      border-radius: 500px;
    }
    .react-calendar--selectRange .react-calendar__tile--hover {
      background-color: #e6e6e6;
      border-radius: 500px;
    }
  }

  button,
  label {
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 27px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
  }
`
